"use client";

import { useEffect } from "react";
import { useAuthStore } from "@/lib/store";

/**
 * Flips `_hasHydrated` AFTER React has hydrated the server HTML.
 *
 * The auth store itself rehydrates from localStorage synchronously (tokens
 * must be available immediately for the API client), but the *flag* that
 * gates auth-dependent rendering must only flip once hydration is committed —
 * effects run after the hydration commit, so the first client render matches
 * the server HTML exactly. See the persist config in lib/store.ts.
 */
export function AuthHydrationMarker() {
  const setHasHydrated = useAuthStore((s) => s.setHasHydrated);

  useEffect(() => {
    setHasHydrated(true);
  }, [setHasHydrated]);

  return null;
}
